// extracted by mini-css-extract-plugin
export default {"presetReset":"defaultLogo_presetReset__xZcEZ","xl":"defaultLogo_xl__IHuAN","lg":"defaultLogo_lg__nzkse","md":"defaultLogo_md__2sN0t","sm":"defaultLogo_sm__ONbHz"};